// @index(['./*.ts', './*.tsx'], pp => `export * from '${pp.path}';`)
export * from './AccessibilityStore';
export * from './AssetStore';
export * from './BaseStore';
export * from './ChartStore';
export * from './ColumnStore';
export * from './CommentaryStore';
export * from './ConditionalDisclaimerStore';
export * from './ConfigStore';
export * from './DataStore';
export * from './DisclaimerStore';
export * from './DisclaimerSuperscriptsStore';
export * from './DocumentModuleStore';
export * from './DocumentStore';
export * from './EntityGroupStore';
export * from './EntityStore';
export * from './FeedbackStore';
export * from './FilterStore';
export * from './GlobalDisclaimerStore';
export * from './HistoryStore';
export * from './LoadingStore';
export * from './QueryStore';
export * from './RatingImageStore';
export * from './ScreenSizeStore';
export * from './ToastStore';
export * from './TranslationStore';
export * from './WatchlistStore';
// @endindex

import {
    // @index('./*', f => `${f.name},`)
    AccessibilityStore,
    AssetStore,
    BaseStore,
    ChartStore,
    ColumnStore,
    CommentaryStore,
    ConditionalDisclaimerStore,
    ConfigStore,
    DataStore,
    DisclaimerStore,
    DisclaimerSuperscriptsStore,
    DocumentModuleStore,
    DocumentStore,
    EntityGroupStore,
    EntityStore,
    FeedbackStore,
    FilterStore,
    GlobalDisclaimerStore,
    HistoryStore,
    LoadingStore,
    QueryStore,
    RatingImageStore,
    ScreenSizeStore,
    ToastStore,
    TranslationStore,
    WatchlistStore,
    // @endindex
} from '.';

const data = {
    // @index('./*', f => `${camelCase(f.name)}: ${f.name},`)
    accessibilityStore: AccessibilityStore,
    assetStore: AssetStore,
    baseStore: BaseStore,
    chartStore: ChartStore,
    columnStore: ColumnStore,
    commentaryStore: CommentaryStore,
    conditionalDisclaimerStore: ConditionalDisclaimerStore,
    configStore: ConfigStore,
    dataStore: DataStore,
    disclaimerStore: DisclaimerStore,
    disclaimerSuperscriptsStore: DisclaimerSuperscriptsStore,
    documentModuleStore: DocumentModuleStore,
    documentStore: DocumentStore,
    entityGroupStore: EntityGroupStore,
    entityStore: EntityStore,
    feedbackStore: FeedbackStore,
    filterStore: FilterStore,
    globalDisclaimerStore: GlobalDisclaimerStore,
    historyStore: HistoryStore,
    loadingStore: LoadingStore,
    queryStore: QueryStore,
    ratingImageStore: RatingImageStore,
    screenSizeStore: ScreenSizeStore,
    toastStore: ToastStore,
    translationStore: TranslationStore,
    watchlistStore: WatchlistStore,
    // @endindex
};

export type StoreKey = keyof typeof data;
export default data;



// WEBPACK FOOTER //
// ./src/stores/index.ts